import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df63a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner tac"
}
const _hoisted_2 = { class: "tac" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "적용될 연월", -1))
const _hoisted_4 = { class: "btnColorPink" }
const _hoisted_5 = { class: "tac mr-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "불러올 연월", -1))
const _hoisted_7 = {
  class: "btnColorUpdate",
  style: {"width":"auto"}
}
const _hoisted_8 = { class: "SsTbTr" }
const _hoisted_9 = {
  class: "tal",
  style: {"display":"flex","justify-content":"left","align-items":"center"}
}
const _hoisted_10 = { class: "tac" }
const _hoisted_11 = { class: "tac" }
const _hoisted_12 = { class: "tac" }
const _hoisted_13 = { class: "tac" }

import store from "@/store";
import axios from "axios";
import { computed, ref, watch } from "vue";
import { format, parse, subMonths } from "date-fns";

interface Header {
  title: string;
  key: string;
  align: string;
  sortable: boolean;
}

interface Employee {
  empNum: string;
  empName: string;
  empJob: string;
  empOutDate: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WageBasicLoadEmp',
  emits: ["success"],
  setup(__props, { emit: __emit }) {

const dialog = ref(false);
const code = ref<string>(store.state.AdminSisulCode || '');

const parsedDate = ref(parse(store.state.AdminYYMM || '2023-01', "yyyy-MM", new Date()));
const oneMonthAgo = ref(subMonths(parsedDate.value, 1));
const currentDate = ref(oneMonthAgo.value);
const date = ref(format(currentDate.value, "yyyy-MM"));
const currentMonthDisplay = computed(() => {
  return isNaN(currentDate.value.getTime()) ? '' : format(currentDate.value, "yyyy-MM");
});

const emit = __emit;
const loading = ref(false);
const empList = ref<Employee[]>([]);
const selectEmp = ref<string[]>([]);
const dialogOpen = async () => {
  dialog.value = true;
  selectEmp.value = [];
  await getBeforeMonthEmpList();
};
const headersArr = ref<Header[]>([
  { title: "No.", key: "index", align: "center", sortable: false },
  { title: "사원번호", key: "empNum", align: "center", sortable: true },
  { title: "이름", key: "empName", align: "center", sortable: true },
  { title: "직위", key: "empJob", align: "center", sortable: true },
  { title: "퇴사일", key: "empOutDate", align: "center", sortable: true },
]);

const allSelectEmp = () => {
  if (selectEmp.value.length === empList.value.length) {
    selectEmp.value = [];
  } else {
    selectEmp.value = empList.value.map((emp) => emp.empNum);
  }
};
const notSelectEmp = () => {
  dialog.value = false;
};
watch(
  () => store.state.AdminYYMM,
  (newValue) => {
    if (newValue) {
      const parsedNewDate = parse(newValue, "yyyy-MM", new Date());
      oneMonthAgo.value = subMonths(parsedNewDate, 1);
      currentDate.value = oneMonthAgo.value; // currentDate를 직접 업데이트
      date.value = format(currentDate.value, "yyyy-MM");
    }
  }
);

const formatYm = (value: string) => {
  if (!value) return "";
  const [year, month] = value.split("-");
  return `${year}년 ${month}월`;
};
const saveBeforeMonthEmpList = async () => {
  if (loading.value) return;
  if (selectEmp.value.length === 0) {
    alert("불러올 사원정보를 선택해주세요.");
    return;
  }
  const adminYYMM = store.state.AdminYYMM;
  if (!adminYYMM) {
    alert("날짜 정보가 없습니다.");
    return;
  }
  const isConfirmed = window.confirm(`${formatYm(
    adminYYMM
  )}의 기존 정보와 중복되는 정보는
자동으로 덮어쓰기 처리됩니다. 
${formatYm(date.value)}의 사원정보를 불러오시겠습니까?
`);
  if (isConfirmed) {
    loading.value = true;
    const insertDate = adminYYMM;
    const selectDate = date.value;
    try {
      const response = await axios.post(
        `/api/saveBeforeMonthEmpList/${insertDate}/${selectDate}/${code.value}`,
        { form: selectEmp.value }
      );
      const result = response.data;
      if (result.success === true) {
        emit("success");
        dialog.value = false;
      } else {
        alert("사원 불러오기에 실패하였습니다. 관리자에게 문의해주세요.");
      }
    } catch (error) {
      alert("사원 불러오기를 처리할 수 없습니다.");
      console.error(error);
    } finally {
      loading.value = false;
    }
  } else {
    return;
  }
};
const getBeforeMonthEmpList = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get(
      `/api/getBeforeMonthEmpList/${code.value}/${date.value}`
    );
    const responseData = response.data;
    if (responseData) {
      empList.value = responseData;
      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogOpen())),
      class: "btnColorWhite"
    }, {
      default: _withCtx(() => [
        _createTextVNode("전월 내역 불러오기")
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialog).value = $event)),
      width: "550px",
      class: "fontNotoSans400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                  : (_openBlock(), _createBlock(_component_v_data_table, {
                      key: 1,
                      "no-data-text": "데이터가 존재하지 않습니다.",
                      "fixed-header": "",
                      density: "compact",
                      scrollable: "",
                      headers: headersArr.value,
                      items: empList.value,
                      "item-value": "name",
                      class: "SsTb fontNotoSans400",
                      style: {"height":"calc(100vh - 200px)","max-height":"600px","overflow-y":"hidden","position":"relative"},
                      "items-per-page": 50,
                      "items-per-page-options": [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: 200, title: '200' },
            // { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
          ]
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_v_toolbar, { flat: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar_title, {
                              class: "fontNotoSans700",
                              style: {"max-width":"300px"}
                            }, {
                              default: _withCtx(() => [
                                (selectEmp.value.length !== empList.value.length)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      onClick: allSelectEmp,
                                      class: "btnColorWhite",
                                      style: {"width":"100px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("전체체크")
                                      ]),
                                      _: 1
                                    }))
                                  : (selectEmp.value.length === empList.value.length && empList.value.length)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        onClick: allSelectEmp,
                                        class: "btnColorWhite",
                                        style: {"width":"100px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("전체체크해제")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_2, [
                              _hoisted_3,
                              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(store).state.AdminYYMM), 1)
                            ]),
                            _createVNode(_component_v_divider, {
                              class: "mx-4",
                              inset: "",
                              vertical: ""
                            }),
                            _createElementVNode("div", _hoisted_5, [
                              _hoisted_6,
                              _createElementVNode("p", _hoisted_7, _toDisplayString(currentMonthDisplay.value), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      item: _withCtx(({ item, index }) => [
                        _createElementVNode("tr", _hoisted_8, [
                          _createElementVNode("td", _hoisted_9, [
                            _createVNode(_component_v_checkbox, {
                              style: {"display":"inline-block"},
                              modelValue: selectEmp.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectEmp).value = $event)),
                              value: item.empNum,
                              color: "secondary",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "value"]),
                            _createElementVNode("span", null, _toDisplayString(index + 1) + ".", 1)
                          ]),
                          _createElementVNode("td", _hoisted_10, _toDisplayString(item.empNum), 1),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(item.empName), 1),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(item.empJob), 1),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(item.empOutDate), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "items-per-page-options"])),
                _createVNode(_component_v_btn, {
                  style: {"width":"100%"},
                  class: "btnColorPurple mb-1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (saveBeforeMonthEmpList()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("불러오기")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  style: {"width":"100%"},
                  class: "btnColorDark",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (notSelectEmp()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("취소")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})